exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".require[data-v-2f5d5565]:before{content:'* ';color:red}[data-v-2f5d5565] .tableBB .el-input__inner{border:none !important}.operation[data-v-2f5d5565]{text-align:right}.header[data-v-2f5d5565]{padding:24px;font-family:Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;font-weight:400;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:transparent;font-size:18px;font-weight:bolder}\n", ""]);

// exports
